<template>
  <v-cotainer>
    <v-data-iterator
      :items="items"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :search="search"
      content-tag="v-layout"
      row
      wrap
    >
    <template slot="header">
        <v-toolbar class="primary white--text">
            <v-toolbar-title>Product Group-wise Reports</v-toolbar-title>
            <v-spacer/>
            <v-text-field
                v-model="search"
                clearable
                outlined
                solo
                prepend-inner-icon="mdi-magnify"
                label="Search"
            ></v-text-field>
            <v-spacer/>
            <v-btn icon dark disabled @click="print()">
              <v-icon>print</v-icon>
            </v-btn>
            <!-- <router-link to="/Dashboard">
                <v-btn icon>
                <v-icon class="white--text">close</v-icon>
                </v-btn>
            </router-link> -->
        </v-toolbar>
        <v-toolbar class="mb" color="white white--text" flat>
          <v-layout row>
            <v-flex>
              <v-autocomplete
              dense 
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
              ></v-autocomplete>
            </v-flex>
            <v-spacer/>
            <v-flex>
              <v-menu
                :close-on-content-click="false"
                v-model="datepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  clearable
                  v-model="selectedDate"
                  single-line
                  label="Date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="selectedDate" @input="datepicker = false" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-toolbar>
      </template>
      <template v-slot:item="props">  
        <v-flex
          xs12
          sm6
          md4
          lg3
        >
          <v-card>
            <v-card-title class="primary white--text">
                <h4>{{ props.item.name }}</h4>
                <v-spacer/>
                <h4>Total</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>Calories:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.calories }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Fat:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.fat }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Carbs:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.carbs }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Protein:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.protein }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Sodium:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.sodium }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Calcium:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.calcium }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Iron:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.iron }}</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </template>
    </v-data-iterator>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import ExpandCard from '../Balancesheet/expandCard';
import {convertToCashBook } from "../../../utils/pdf-reports/information-reports";
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
  export default {
    data: () => ({
      rowsPerPageItems: [4, 8, 12],
      search: '',
      pagination: {
        rowsPerPage: 4
      },
      items: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          sodium: 87,
          calcium: '14%',
          iron: '1%'
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          sodium: 129,
          calcium: '8%',
          iron: '1%'
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          sodium: 337,
          calcium: '6%',
          iron: '7%'
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          sodium: 413,
          calcium: '3%',
          iron: '8%'
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          sodium: 327,
          calcium: '7%',
          iron: '16%'
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          sodium: 50,
          calcium: '0%',
          iron: '0%'
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          sodium: 38,
          calcium: '0%',
          iron: '2%'
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          sodium: 562,
          calcium: '0%',
          iron: '45%'
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          sodium: 326,
          calcium: '2%',
          iron: '22%'
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          sodium: 54,
          calcium: '12%',
          iron: '6%'
        }
      ]
    }),
    created() {
      this.$bindAsArray('firm', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
    },
    computed: {
      ...mapGlobalGetters(['selectedBrand','finYear']),
      firmsByBrand () {
        // return selected brand firms
        let firms = this.firm
          .filter((item) => item['brand'] === this.selectedBrand)
          firms.map((item) => {
            if (item.defaultFirm) {
              this.selectedFirm = item;
            }
          })
          return firms;
      },
    }  
  }
</script>


// WEBPACK FOOTER //
// src/components/Informations/ProductReports/ProductGroupReports.vue